<template>
  <div v-if="show" class="tabbar-container">
    <!-- <div class="ill-lobby-img-bottom-tab-box">
      <img
        :src="
          getImageUrlWithCDN_TEST('/home/ill-lobby-img/ill-lobby-img-bottom-tab-L.png', 'local')
        "
        class="ill-lobby-img tab-l"
        alt=""
      />
      <img
        :src="
          getImageUrlWithCDN_TEST('/home/ill-lobby-img/ill-lobby-img-bottom-tab-R.png', 'local')
        "
        class="ill-lobby-img tab-r"
        alt=""
      />
    </div> -->

    <van-tabbar v-model="active" route placeholder @change="onChange">
      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <div class="item-icon-box">
              <i class="svg-box chxy-row-c-c">
                <SvgIcon
                  name="tabbar-home"
                  :fill="`var(--tabbar-menu-icon${active === 0 ? '-checked' : ''})`"
                  :size="26"
                />
              </i>
              <i class="svg-box chxy-row-c-c">
                <SvgIcon
                  name="tabbar-home_checked"
                  :fill="`var(--tabbar-menu-icon-secondary${active === 0 ? '-checked' : ''})`"
                  :size="26"
                />
              </i>
            </div>
            <span :class="active == 0 ? 'checkColor' : 'defColor'">
              {{ $t('tab-bar-index.home') }}
            </span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <div class="item-icon-box">
              <i class="svg-box chxy-row-c-c">
                <SvgIcon
                  name="tabbar-activity"
                  :fill="`var(--tabbar-menu-icon${active === 1 ? '-checked' : ''})`"
                  :size="26"
                />
              </i>
              <i class="svg-box chxy-row-c-c">
                <SvgIcon
                  name="tabbar-activity_checked"
                  fill="var(--tabbar-menu-icon-secondary)"
                  :size="26"
                />
              </i>
            </div>
            <span :class="active == 1 ? 'checkColor' : 'defColor'">
              {{ $t('tab-bar-index.offers') }}
            </span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <template v-if="hadToken">
              <div class="item-icon-box">
                <i class="svg-box chxy-row-c-c">
                  <SvgIcon
                    name="tabbar-agent"
                    fill="var(--tabbar-menu-icon)"
                    :size="26"
                    not-need-fill
                  />
                </i>
                <i class="svg-box chxy-row-c-c">
                  <SvgIcon
                    name="tabbar-agent_checked"
                    fill="var(--tabbar-menu-icon-secondary)"
                    :size="26"
                    not-need-fill
                  />
                </i>
              </div>
              <span class="defColor">{{ $t('tab-bar-index.promotion') }}</span>
            </template>
            <template v-else>
              <div class="item-icon-box">
                <i class="svg-box chxy-row-c-c">
                  <SvgIcon
                    name="tabbar-center_login"
                    fill="var(--tabbar-menu-icon)"
                    fill-secondary="var(--tabbar-menu-icon-secondary)"
                    :size="26"
                    not-need-fill
                  />
                </i>
              </div>
              <span class="defColor">{{ $t('tab-bar-index.login') }}</span>
            </template>
          </div>
        </template>
      </van-tabbar-item>

      <!-- badge="3" replace to="/carteira" -->
      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <div class="item-icon-box">
              <i class="svg-box chxy-row-c-c">
                <SvgIcon
                  name="tabbar-suporte"
                  fill="var(--tabbar-menu-icon)"
                  fill-secondary="var(--tabbar-menu-icon-secondary)"
                  :size="26"
                  not-need-fill
                />
              </i>
            </div>
            <span class="defColor">{{ $t('tab-bar-index.support') }}</span>
          </div>
        </template>
      </van-tabbar-item>

      <!-- replace to="/profile" -->
      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <div class="item-icon-box">
              <i class="svg-box chxy-row-c-c">
                <SvgIcon
                  name="tabbar-perfil_checked"
                  fill="var(--tabbar-menu-icon-secondary)"
                  :size="26"
                />
              </i>
              <i class="svg-box chxy-row-c-c">
                <SvgIcon
                  name="tabbar-perfil"
                  :fill="`var(--tabbar-menu-icon${active === 4 ? '-checked' : ''})`"
                  :size="26"
                />
              </i>
            </div>
            <span :class="active == 4 ? 'checkColor' : 'defColor'">
              {{ $t('tab-bar-index.profile') }}
            </span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>

    <Deposito ref="depositoRef" />
    <LoginRegisterPopup ref="LoginRegisterRef" />
  </div>
</template>

<script setup>
import { rootRouteList } from '@/config/routes'
import { isLogin } from '@/utils/auth'
import { STORAGE_TOKEN_KEY } from '@/stores/mutation-type'
// import { useRouter } from 'vue-router'
// import { useEventListener } from '@vueuse/core'
import { useUserStore } from '@/stores'
const depositoRef = ref()
const router = useRouter()
const userStore = useUserStore()
const hadToken = computed(() => {
  return !!userStore.userInfo.token
})
const active = ref(0)
const LoginRegisterRef = ref('')
// 定义路由名称到Tab索引的映射
const routeToIndex = {
  Home: 0,
  Promocao: 2,
  Activity: 1,
  Carteira: 3,
  Profile: 4,
}

const route = useRoute()

// 根据当前路由设置active状态
const setActiveTab = () => {
  if (route.name && Object.prototype.hasOwnProperty.call(routeToIndex, route.name)) {
    active.value = routeToIndex[route.name]
    sessionStorage.setItem('active', active.value.toString())
  }
}

// 监听路由变化
watch(
  () => route.name,
  () => {
    setActiveTab()
  },
  { immediate: true }
)

// // 监听 localStorage 变化
// useEventListener(window, 'storage', (event) => {
//   if (event.key === 'active') {
//     const newValue = parseInt(event.newValue, 10)
//     if (!isNaN(newValue) && newValue >= 0 && newValue <= 4) {
//       active.value = newValue
//     }
//   }
// })

onMounted(() => {
  // 初始化时从 localStorage 读取状态
  const savedActive = sessionStorage.getItem('active')
  if (savedActive !== null) {
    const parsedActive = parseInt(savedActive, 10)
    if (!isNaN(parsedActive) && parsedActive >= 0 && parsedActive <= 4) {
      active.value = parsedActive
    }
  } else if (hadToken.value) {
    setActiveTab()
  } else {
    active.value = 0
  }
})

const onChange = (index) => {
  if (!hadToken.value) {
    active.value = 0
    sessionStorage.setItem('active', '0')
    nextTick(() => {
      LoginRegisterRef.value?.openPopupRegLogin()
    })
    return
  }
  if (index == 2) {
    // active.value = routeToIndex[route.name] || 0
    // localStorage.setItem('active', active.value.toString())
    const PromocaoType = localStorage.getItem('PromocaoType')
    if (PromocaoType && PromocaoType !== undefined) {
      router.push({
        name: 'Promocao',
        query: {
          type: +PromocaoType,
        },
      })
    } else {
      router.push('/Promocao')
    }
    return
  } else if (index == 1) {
    const ActivityType = localStorage.getItem('ActivityType')
    if (ActivityType && ActivityType !== undefined) {
      router.push({
        name: 'Activity',
        query: {
          type: +ActivityType,
        },
      })
    } else {
      router.push('/activity')
    }
    return
  } else if (index == 3) {
    // active.value = routeToIndex[route.name] || 0
    // sessionStorage.setItem('active', active.value.toString())
    // depositoRef.value?.openPopupDeposit()
    active.value = routeToIndex[route.name] || 0
    router.push('/Messages')
    return
  } else if (index == 4) {
    active.value = routeToIndex[route.name] || 0
    sessionStorage.setItem('active', active.value.toString())
    router.replace('/profile')
    return
  } else {
    active.value = 0
    sessionStorage.setItem('active', '0')
    router.replace('/')
  }
}

const show = computed(() => {
  if (route.name && rootRouteList.includes(route.name)) {
    return true
  }
  return false
})
</script>
<style scoped lang="scss">
.tabbar-container {
  position: relative;
  height: 62px;
  background: var(--tabbar-view-bg);
  --van-tabbar-background: transparent;
  --van-tabbar-item-active-background: var(--tabbar-menu-active-bg);
  --van-tabbar-item-text-color: var(--tabbar-menu-name);
  --van-tabbar-item-active-color: var(--tabbar-menu-name-checked);

  .ill-lobby-img-bottom-tab-box {
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;

    .ill-lobby-img {
      position: absolute;
      top: 0;
      width: 83px;
      height: 62px;
      pointer-events: none;

      &.tab-l {
        left: 0;
      }
      &.tab-r {
        right: 0;
      }
    }
  }
}
:deep(.van-tabbar__placeholder) {
  height: 62px !important;

  .van-tabbar {
    height: 62px;
    z-index: 1;

    &::after {
      border: 0 solid var(--tabbar-view-bg);
    }
  }

  .van-tabbar-item {
    position: relative;
    z-index: 2;
  }
}
.checkColor,
.defColor {
  position: relative;
  z-index: 3;
}
.checkColor {
  margin-top: 3px;
  font-size: 12px;
  color: var(--tabbar-menu-name-checked);
}
.defColor {
  margin-top: 3px;
  font-size: 12px;
}

.tabbar-item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  .item-icon-box {
    position: relative;
    width: 26px;
    height: 26px;

    .svg-box {
      position: absolute;
    }
  }

  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;

    .icon {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
